/* eslint-disable no-unused-vars */
const getCommonCellCardStyle = palette => ({
  position: 'relative',
  flexShrink: 1,
  flexGrow: 1,
  borderRadius: 6,
  backgroundColor: palette.neutralLight,
  filter: 'drop-shadow(0px 0.6px 1.8px rgba(0, 0, 0, 0.1)) drop-shadow(0px 3.2px 7.2px rgba(0, 0, 0, 0.13))',
});

export const getCellCardStyle = ({ components, core: { palette = {} } = {} } = {}) => ({
  cellCardContainer: {
    ...getCommonCellCardStyle(palette),
  },
});

export const getCellCardWithOverlayStyle = ({ components, core: { palette = {} } = {} } = {}) => {
  const activeStyle = {
    '& .cell-overlay': {
      opacity: 1,

      '& .cell-overlay-actions': {
        opacity: 1,
        transform: 'translate(0px, -10px)',
      },
    },
    '& .cell-decorative-label-container': {
      '& .label-secondary-text': {
        opacity: 1,
        transform: 'translate(10px, 0px)',
      },
    },
  };
  return {
    cellCardContainer: getCommonCellCardStyle(palette),

    cellCardContainerOverflow: {
      overflow: 'hidden',
    },

    cellCardWithOverlayContainer: {
      '& .cell-overlay-actions': {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        position: 'relative',
        opacity: 0.2,
        top: 10,
        transition: 'opacity 0.5s 0.1s, transform 0.3s 0.1s',
      },

      '& .static-cell-overlay-items': {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        button: 0,
      },

      '&:hover, &:focus-within': activeStyle,
    },
    focused: activeStyle,
  };
};
